/**
 * @route /
 * @title Adventure Academy
 * @prerender false
 * @meta {
 *   customHTMLClasses: ['is-nmhp', 'is-nmhp-blue-bg'],
 *   blockedForMembers: true,
 *   pageInfo: [{
 *     name: 'page',
 *     id: 'home'
 *   }]
 * }
 * @linkTag {
 *  rel: 'canonical',
 *  href: 'https://www.adventureacademy.com/'
 * }
 * @metaTag {
 *  property: "og:title",
 *  content: "Adventure Academy"
 * }
 * @metaTag {
 *  name: "description",
 *  content: "From the creators of ABCmouse.com, Adventure Academy is the newest educational product from Age of  Learning Inc. featuring endless game play. Adventure Academy is an educational product that combines an Elementary School curriculum with an interactive 3D world. Sign up to buy or get the latest news! Adventure Academy combines an Elementary School curriculum with an interactive 3D world that provides the perfect environment for contextual learning. An epic learning adventure awaits! Experience the immersive and educational curriculum of Adventure Academy, from the team that brought you ABCmouse."
 * }
 * @metaTag {
 *  name: "keywords",
 *  content: "Learn, learning, reading, math, early learning, early childhood education, online books, teacher, digital learning, online learning, online games, Coolmath4kids, Makemegenius, Funbrain, adaptedmind, Lego, Minecraft, Roblox, Mario Party, Pokemon"
 * }
 * @metaTag {
 *  property: "og:description",
 *  content: "From the creators of ABCmouse.com, Adventure Academy is the newest educational product from Age of  Learning Inc. featuring endless game play. Adventure Academy is an educational product that combines an Elementary School curriculum with an interactive 3D world. Sign up to buy or get the latest news! Adventure Academy combines an Elementary School curriculum with an interactive 3D world that provides the perfect environment for contextual learning. An epic learning adventure awaits! Experience the immersive and educational curriculum of Adventure Academy, from the team that brought you ABCmouse."
 * }
 * @metaTag {
 *  property: "og:url",
 *  href: "https://www.adventureacademy.com/"
 * }
 */
import {pageConditions} from './__config/conditions';
import {resolveCondition} from '../../modules/page-load-utils';

export default async () => {
  const resolvedPage = resolveCondition(pageConditions);
  return (await resolvedPage.resolve()).default;
};
